import { render, staticRenderFns } from "./ManageCardForm.vue?vue&type=template&id=16a5921e"
import script from "./ManageCardForm.vue?vue&type=script&lang=ts"
export * from "./ManageCardForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports